import { useQuery } from '@tanstack/react-query';
import { getCartransfer } from '../api/cartransferService';

/**
 * Hook para obtener un cartransfer por ID
 * @param {string|number} id - ID del cartransfer
 */
export function useCartransferQuery(id) {
  return useQuery({
    queryKey: ['cartransfer', id],
    queryFn: async () => {
      const response = await getCartransfer(id);
      return response.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos (cacheTime cambió a gcTime en v5)
    retry: 2,
    retryDelay: 1000,
    refetchOnWindowFocus: false,
  });
} 